module.exports = __webpack_public_path__ + "img/641e73ca-098c-4fd3-a8f1-69d4a1942f8f.c71d3256.webp";